module.exports = __webpack_public_path__ + "img/qr-camera.e4c1e9ad.png";